module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dbbe6d27575006d24710126e4fb467e0.png";